let productSwiper2 = new Swiper(".mySwiper2", {
    centeredSlides: true,
    speed: 600,
    navigation: {
      nextEl: '.product-section__button-next',
      prevEl: '.product-section__button-prev',
    },
    scrollbar: {
      el: '.product-section__scrollbar',
    },
    breakpoints: {
      770: {
        slidesPerView: 2,
        centeredSlides: false,
        noSwiping: true,
        allowSlidePrev: false,
			allowSlideNext: false
      },
    }
  });

  const sizeGuideLink = document.querySelector('.size-guide-link');
  const modal = document.querySelector('.modal-size');
  const modalClose = document.querySelector('.close-modal');
  const bodyLock = document.querySelector('body');
  
  // Check if both modal and modalClose elements exist
  if (modal && modalClose) {
    sizeGuideLink.addEventListener("click", function(e) {
      e.preventDefault(); // Changed 'event' to 'e' for consistency
      bodyLock.classList.add('_lock');
      modal.classList.add('active');
  
      // Close modal if the user clicks outside the modal content
      modal.addEventListener(
        "click",
        function(event) {
          if (!event.target.closest(".modal-content")) {
            closeModal();
          }
        },
        false
      );
      
      // Close modal when the close button is clicked
      modalClose.addEventListener("click", function() {
        closeModal();
      });
    });
  }
  
  // Function to close the modal
  function closeModal() {
    modal.classList.remove('active');
    bodyLock.classList.remove('_lock');
  }

	class VariantSelects extends HTMLElement {
		constructor() {
			super();
			this.addEventListener('change', this.onVariantChange);
		}
	
		onVariantChange() {
			this.updateOptions();
			this.updateMasterId();
			this.toggleAddButton(true, '', false);
			this.updatePickupAvailability();
			this.removeErrorMessage();
	
			if (!this.currentVariant) {
				this.toggleAddButton(true, '', true);
				this.setUnavailable();
			} else {
				// this.updateMedia();
				this.updateURL();
				this.updateVariantInput();
				this.renderProductInfo();
				this.updateShareUrl();
			}
		}
	
		updateOptions() {
			this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
		}
	
		updateMasterId() {
			this.currentVariant = this.getVariantData().find((variant) => {
				return !variant.options.map((option, index) => {
					return this.options[index] === option;
				}).includes(false);
			});
		}
	
		// updateMedia() {
		//   if (!this.currentVariant) return;
		//   if (!this.currentVariant.featured_media) return;
	
		//   const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
		//   mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
	
		//   const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
		//   if (!modalContent) return;
		//   const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
		//   modalContent.prepend(newMediaModal);
		// }
	
		updateURL() {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
			window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
		}
	
		updateShareUrl() {
			const shareButton = document.getElementById(`Share-${this.dataset.section}`);
			if (!shareButton || !shareButton.updateUrl) return;
			shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
		}
	
		updateVariantInput() {
			const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
			productForms.forEach((productForm) => {
				const input = productForm.querySelector('input[name="id"]');
				input.value = this.currentVariant.id;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			});
		}
	
		updatePickupAvailability() {
			const pickUpAvailability = document.querySelector('pickup-availability');
			if (!pickUpAvailability) return;
	
			if (this.currentVariant && this.currentVariant.available) {
				pickUpAvailability.fetchAvailability(this.currentVariant.id);
			} else {
				pickUpAvailability.removeAttribute('available');
				pickUpAvailability.innerHTML = '';
			}
		}
	
		removeErrorMessage() {
			const section = this.closest('section');
			if (!section) return;
	
			const productForm = section.querySelector('product-form');
			if (productForm) productForm.handleErrorMessage();
		}
	
		renderProductInfo() {
			fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(responseText, 'text/html')
					const destination = document.getElementById(`price-${this.dataset.section}`);
					const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
					if (source && destination) destination.innerHTML = source.innerHTML;
	
					const price = document.getElementById(`price-${this.dataset.section}`);
				});
		}
	
		toggleAddButton(disable = true, text, modifyClass = true) {
			const productForm = document.getElementById(`product-form-${this.dataset.section}`);
			if (!productForm) return;
			const addButton = productForm.querySelector('[name="add"]');
			const addButtonText = productForm.querySelector('[name="add"] > span');
			if (!addButton) return;
	
			if (disable) {
				addButton.setAttribute('disabled', 'disabled');
				if (text) addButtonText.textContent = text;
			} else {
				addButton.removeAttribute('disabled');
				addButtonText.textContent = window.variantStrings.addToCart;
			}
	
			if (!modifyClass) return;
		}
	
		setUnavailable() {
			const button = document.getElementById(`product-form-${this.dataset.section}`);
			const addButton = button.querySelector('[name="add"]');
			const addButtonText = button.querySelector('[name="add"] > span');
			const price = document.getElementById(`price-${this.dataset.section}`);
			if (!addButton) return;
			addButtonText.textContent = window.variantStrings.unavailable;
			if (price) price.classList.add('visibility-hidden');
		}
	
		getVariantData() {
			this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
			return this.variantData;
		}
	}
	
	customElements.define('variant-selects', VariantSelects);
	
	class VariantRadios extends VariantSelects {
		constructor() {
			super();
		}
	
		updateOptions() {
			const fieldsets = Array.from(this.querySelectorAll('fieldset'));
			this.options = fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
			});
		}
	}
	
	customElements.define('variant-radios', VariantRadios);

  $(function() {
    var button1 = $(".product-section__button-wrapper.mobile");
    var button2 = $(".product-section__sticky-button")
    $(window).scroll(function() {    
        var scroll = $(window).scrollTop();
    
        if (scroll >= 200) {
           if(button1.has( "#addToCart" ).length){
            button1.css("position", "inherit");
           } else {
            button1.css("position", "static");
           }
            button2.css("position", "inherit");
        } else {
          if(button1.has( "#addToCart" ).length){
             button1.css("position", "fixed");
          } else {
             button1.css("position", "static");
          }
           
            button2.css("position", "fixed");
        }
    });
});

document.getElementById('scrollToElement').addEventListener('click', function() {
  var element = document.getElementById('product-section__variant-buttons');
  
  if (element) {
    var adjustedScrollPosition = element.getBoundingClientRect().top + window.scrollY - 50;

    window.scrollTo({
        top: adjustedScrollPosition,
        behavior: 'smooth'
    });
  }
});